// ---------------- ThemeConfig ----------------
export interface ThemeConfig {
  mainColor: string;
  primaryColor: string;
  primaryBorderColor: string;
  primarybuttonBackGroundColor: string;
  secondaryColor: string;
  writeColorbuttonBackGroundColor: string;
  writeColorbuttonBackGroundColor1: string;
  writeColor: string;
  boxshadow: string;
  backgroundGradient: string;
  tabColor: string;
  tab1Color: string;
  tab2Color: string;
  tab3Color: string;
}

// ---------------- FirebaseConfig ----------------
export interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId: string;
}

// ---------------- EnvConfig ----------------
export interface EnvConfig {
  BaseUrl: string;
  RedirectBaseURL: string;
  RedirectUrl: string;
  LogoutUrl: string;
  clientId: string;
  responseType: string;
  routingTypeCode: string;
  codeChallengeMethod: string;
  theme: ThemeConfig;
  consentAPi: string;
  staticUi: string;
  VITE_FIREBASE_VAPID_KEY: string;
  firebase: FirebaseConfig;
}

// ---------------- internal state ----------------
let _config: EnvConfig | null = null;

// ---------------- loadEnvConfig ----------------
export const loadEnvConfig = async (): Promise<EnvConfig> => {
  if (_config) return _config;

  const response = await fetch("/config/env.json");

  if (!response.ok) {
    throw new Error("Failed to load env.json");
  }

  const json = await response.json();

  if (!json.environments) {
    throw new Error("Missing environments object in env.json");
  }

  _config = json.environments as EnvConfig;

  return _config;
};

// ---------------- getEnvConfig ----------------
export const getEnvConfig = (): EnvConfig => {
  if (!_config) {
    throw new Error("Call loadEnvConfig() first");
  }
  return _config;
};

// ---------------- getBaseUrl ----------------
export const getBaseUrl = (): string => {
  if (!_config) {
    throw new Error("Call loadEnvConfig() first");
  }

  return _config.BaseUrl.endsWith("/")
    ? _config.BaseUrl
    : `${_config.BaseUrl}/`;
};
